import {AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import { GenericConfig } from '@signature-it/ngx-generic/config';
import { CmsComponent } from '@signature-it/ngx-generic/components/cms';
import {ShareDataService} from '@signature-it/ngx-generic/services';

declare let $: any;

@Component({
    selector: 'main-footer',
    templateUrl: './main-footer.html',
    standalone: false
})
export class MainFooterComponent implements OnInit, AfterViewInit {
    @Input() cmsTitleFooter :string;
    cmsTitle: string;
    @ViewChild('cmsComp') cmsComp: CmsComponent;
    @ViewChild('containerRef') containerRef: ElementRef;
    afterInsertElement = false;
    isDam: boolean = GenericConfig.isDam ? true : false;
    isRestricted = false;

    constructor(protected elRef: ElementRef,
                public shareSvc: ShareDataService) {}

    ngOnInit(): void {
        if (this.cmsTitleFooter) {
            this.cmsTitle = this.cmsTitleFooter;
        } else {
            this._getFooterCmsName();
        }
    }

    _getFooterCmsName() {
        this.shareSvc.isRestrictedLogin$.subscribe(isRestricted => {
            const name = GenericConfig.footerCmsName ?
                GenericConfig.footerCmsName :
                (GenericConfig.isDam) ? 'ngx-footer-media' : 'ngx-footer';
            if(isRestricted !== null) {
                this.cmsTitle = isRestricted ? 'restricted-login-footer-cms' : name;
            }
        });
    }

    ngAfterViewInit(): void {
        this.cmsComp
            .contentLoader$
            .subscribe(
                (result) => {
                    if (result && result.title === this.cmsTitle) {
                        setTimeout(() => {
                            // TODO: create directive for this
                            const $container = $(this.containerRef.nativeElement);
                            const $cms = $(this.elRef.nativeElement).find(`cms #${this.cmsTitle}`);
                            // components to replace
                            $container.children().map((ix, comp) => {
                                const elName = comp.localName || '';
                                const $cmsEl = $cms.find(elName);
                                if ($cmsEl.length) {
                                    const $containerEl = $container.find(elName);
                                    if ($containerEl.length) {
                                        $containerEl.insertBefore($cmsEl);
                                    }
                                }
                            });
                            this.afterInsertElement = true;
                        }, 100);
                    }
                }
            );
    }

}
